import { defineMessages } from 'react-intl';

export default defineMessages({
    trmType: {
        id: 'quoteandbind.farm.policy-info.Term Type',
        defaultMessage: 'Term Type'
    },
    insuranceScoreConsent: {
        id: 'quoteandbind.farm.policy-info.Insurance Score Consent',
        defaultMessage: 'Insurance Score Consent'
    },
    expirationDate: {
        id: 'quoteandbind.farm.policy-info.Expiration Date',
        defaultMessage: 'Expiration Date'
    },

    priorPolicyInformation: {
        id:"quoteandbind.farm.policy-info.Prior Policy Information",
        defaultMessage: 'Prior Policy Information'
    },
    priorCarrierName:{
        id: 'quoteandbind.farm.policy-info.Prior Carrier Name',
        defaultMessage: 'Prior Carrier Name'
    },
    priorPolicy:{
        id: 'quoteandbind.farm.policy-info.Prior Policy #',
        defaultMessage: ' Prior Policy #'
    },
    priorExpirationDate:{
        id: 'quoteandbind.farm.policy-info.Prior Expiration Date',
        defaultMessage: 'Prior Expiration Date'
    },
    numberOfYearsPriorInsurance :{
        id: 'quoteandbind.farm.policy-info.Number of Years Prior Insurance',
        defaultMessage: 'Number of Years Prior Insurance'
    },
    cancelledByInsuranceCompany: {
        id: 'quoteandbind.farm.policy-info.Have you been cancelled by an insurance company in the last 3 years',
        defaultMessage: 'Have you been cancelled by an insurance company in the last 3 years?'
    },
    offerings: {
        id:"quoteandbind.farm.policy-info.Offering",
        defaultMessage: 'Offering'
    }, 
   offeringsSelection: {
        id:"quoteandbind.farm.policy-info.Offering Selection",
        defaultMessage: 'Offering Selection'
    },
    errorOnNotFilledCanceledPolicyData: {
        id: 'quoteandbind.farm.policy-info.errorOnNotFilledCanceledPolicyData',
        defaultMessage: "Have you ever been cancelled by an insurance company in the last 3 years? : There are one or more prior cancellations for this insured in past 3 years by an insurance company, but no details are provided. Fill the required information for Prior Cancellations"
    },
    errorsOnCurrentPage: {
         id: 'quoteandbind.farm.policy-info.Errors on current page',
         defaultMessage: ' Errors on current page'
    },
    additionalNamedInsured: {
        id:"quoteandbind.farm.policy-details.Additional Named Insureds",
        defaultMessage:"Additional Named Insureds"
    },
    bmsClientCode: {
        id: "quoteandbind.farm.policy-info.BMS Client Code",
        defaultMessage: "BMS Client Code"
      }
});
